import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface AuthRedirectProps {
  students: React.ReactNode;
}

const AuthRedirect: React.FC<AuthRedirectProps> = ({ students }) => {
  const { token } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/select-student', { replace: true });
    }
  }, [token, navigate]);

  if (token) {
    return null;
  }

  return <>{students}</>;
};

export default AuthRedirect;